export const API_BASE_URL = 'https://backend.chseexpress.com';

export const RAZORPAY_KEY_ID = 'rzp_live_NvEkuW14Ie22zW';
